import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/store/types";

export const getAppState = (state: RootState) => state.app;

export function getLanguage() {
  return createSelector([getAppState], state => state.language);
}

export function getCurrentUser() {
  return createSelector([getAppState], state => state.auth?.user);
}